import { boot } from 'quasar/wrappers';
import { createI18n } from 'vue-i18n';
import translations from 'SharedDir/branding/translations';
import { REGION_ENVIRONMENT } from 'PortalDir/constants/app/common';
import pluralizationRussianRule from 'SharedDir/utils/i18n-rules/pluralization-ru';

export type MessageLanguages = keyof typeof translations;

// Type-define 'hmao' as the master schema for the resource
export type MessageSchema = typeof translations['hmao'];

// See https://vue-i18n.intlify.dev/guide/advanced/typescript.html#global-resource-schema-type-definition
/* eslint-disable @typescript-eslint/no-empty-interface */
declare module 'vue-i18n' {
  // define the locale messages schema
  export interface DefineLocaleMessage extends MessageSchema {}

  // define the datetime format schema
  export interface DefineDateTimeFormat {}

  // define the number format schema
  export interface DefineNumberFormat {}
}
/* eslint-enable @typescript-eslint/no-empty-interface */

export default boot(({ app }) => {
  const i18n = createI18n<{ message: MessageSchema }, MessageLanguages>({
    locale: REGION_ENVIRONMENT,
    fallbackLocale: 'hmao',
    pluralizationRules: {
      hmao: pluralizationRussianRule,
      yanao: pluralizationRussianRule
    },
    legacy: false,
    messages: translations,
  });

  app.use(i18n);
});
